/* globals $:false */

import utils from '@cob/ui-genesis/cob.utils.js';

// Component capable of handling a drop down selection list
//
// args:
// * `options`: A list of possible values
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `cssClasses`: A string space separated with a list of css classes to add to the input
// * `readonly`: true or false. Defaults to false
// * `valueChanged(newValue)`: Invoked when a user changes the value,
//
// * `defaultValue`: The default selected option
// * `allowEmptyOption`: If there is an empty option
//
var Select = function(core, options, confs) {
    // when we are called just to set as a prototype
    if(core){
        this._core = core;
       this._$input = undefined;
       this._lastValue = undefined;
       this._options = options;
       this._confs = {
          id: core.locallyUniqueId(),
          cssClasses: undefined,
          readonly: false,
          valueChanged: undefined,

          allowEmptyOption: false,
          defaultValue: undefined
       };

       utils.extend(this._confs, confs, true);
    }
};


Select.prototype.render = function() {
    var _this = this;

    var $html = $([
        '<div class="inline">',
        '<select id="f' + this._confs.id + '" class="field-value cob-field-value">',
        '</select>',
        '</div>'
    ].join(''));

    this._$input = $html.find("select");

    if (this._confs.cssClasses) {
        this._$input.addClass(this._confs.cssClasses);
    }

    if (this._confs.allowEmptyOption) {
        this._$input.append($('<option></option>'));
    }

    this._options.forEach(function(option) {
        if(typeof option === "object"
           && option.i18nFile !== undefined
           && option.i18nKey !== undefined
           && option.value !== undefined){
            const translatedOption = (_this._core.translateString(option.i18nFile, option.i18nKey)
                                      || option.i18nKey);

            _this._$input.append($('<option value="' + option.value + '">' + translatedOption + '</option>'));
        } else{
            _this._$input.append($('<option value="' + option + '">' + option + '</option>'));
        }
    });

    if (this._confs.defaultValue) {
        this._$input.val(this._confs.defaultValue);
    }

    if (this._confs.readonly) {
        this._$input.attr("disabled", "disabled").attr("tabindex", -1);

    } else {
        this._$input.on('paste change', function(){_this._onValueChange()});
    }

    if (this._lastValue) {
        _this.setValue(this._lastValue);
    } else {
        this._lastValue = this._$input.val();
    }

    return $html;
};

Select.prototype.destroy = function() {
    var _this=this;

    if (!this._confs.readonly) {
        this._$input.off('keyup paste change', function(){_this._onValueChange()});
    }
};

Select.prototype.clearError = function() {
    this._$input.removeClass("error");
};

Select.prototype.showError = function() {
    this._$input.addClass("error");
};

Select.prototype.setValue = function(value) {
    if (this._$input) {
        this._$input.val(value);
    }

    // Notify that this field has a new value because
    // I want to update the $auto.join and other fields...
    this._setValue(value);
};

Select.prototype.getValue = function() {
    return this._lastValue;
};

Select.prototype._setValue = function(value) {
    const val = Array.isArray(value) ? value[0] : value

    // We just want to notify
    // when the value changes.
    if (this._lastValue !== val) {
        this._lastValue = val;

        if (this._confs.valueChanged) {
            this._confs.valueChanged(val);
        }
    }
};

Select.prototype._onValueChange = function() {
    this._setValue(this._$input.val());
};

Select.prototype.disableSelf =  function() {
    this._$input.prop("disabled", true).attr("tabindex", -1);
};

Select.prototype.enableSelf =  function() {
    this._$input.removeProp("disabled").removeAttr("tabindex");
};

export default Select;
